/**
 * `creation_log` — measured. The cell carries **two** values, a person and a date, so monday
 * splits the dropdown: `person is` / `person is not` against the creator, then the date rows.
 * `compare_attribute` is `"person"` or `"date"` `[sdl]`.
 *
 * `date is only` is offered by monday and is not modelled — no public operator (open question).
 */
import { DATE_ROWS, condition } from '../filter-conditions.js';
/** Shared with `last_updated`, which monday offers the identical list for. */
export const personAndDateFilterConditions = [
    condition('person is', 'any_of', 'people', { compareAttribute: 'person' }),
    condition('person is not', 'not_any_of', 'people', { compareAttribute: 'person' }),
    condition('date is', 'any_of', 'date', { compareAttribute: 'date' }),
    condition('date is not', 'not_any_of', 'date', { compareAttribute: 'date' }),
    ...DATE_ROWS.filter((row) => row.label !== 'is between').slice(0, 2),
    condition('is between', 'between', 'dateRange'),
    condition('is after', 'greater_than', 'date'),
    condition('is on or after', 'greater_than_or_equals', 'date'),
    condition('is before', 'lower_than', 'date'),
    condition('is on or before', 'lower_than_or_equal', 'date'),
];
export const creationLogFilterConditions = personAndDateFilterConditions;
//# sourceMappingURL=filters.js.map